import { Component, OnInit } from "@angular/core";
import { AlertController, ModalController, NavController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "address-not-found-link",
  templateUrl: "./address-not-found-link.component.html",
  styleUrls: ["./address-not-found-link.component.scss"]
})
export class AddressNotFoundLinkComponent implements OnInit {
  constructor(private nav: NavController, private modalCtrl: ModalController, private translateService:TranslateService, private alertCtrl:AlertController) {}
  ngOnInit() {}

  ngOnDestroy() {}

  async show() {
    const alert = await this.alertCtrl.create({
      header: this.translateService.instant("address.notFound.Title"),
      message: this.translateService.instant("address.notFound.Message"),
      backdropDismiss: true,
      buttons: [
        {
          role: "ok",
          text: this.translateService.instant("buttons.OK"),
        },
      ]
    });
    await alert.present();
    await alert.onDidDismiss();
  }
}
